import React, { useState, useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import PersonForm from "./Components/PersonForm";
import MembershipForm from "./Components/MembershipForm";
import MemberForm from "./Components/Memberform";
import EnquiryForm from "./Components/EnquiryForm";
import Loader from "./Components/Loader";

const PersonFormPage = () => {
  const [selectedForm, setSelectedForm] = useState("person"); 

    useEffect(()=>{
                  document.title="Form | Balaji Badminton Academy"
                },[]);

  return (
    <>
      <Header />
      <Loader/>
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <label style={{ marginRight: "20px" }}>
          <input
            type="radio"
            name="formToggle"
            value="person"
            checked={selectedForm === "person"}
            onChange={() => setSelectedForm("person")}
          />
          Customer
        </label>
        <label>
          <input
            type="radio"
            name="formToggle"
            value="member"
            checked={selectedForm === "member"}
            onChange={() => setSelectedForm("member")}
          />
          Member
        </label>
        <label>
          <input
              type="radio"
              name="formToggle"
              value="enquiry"
              checked={selectedForm === "enquiry"}
              onChange={() => setSelectedForm("enquiry")}
            />
            Enquiry
        </label>
      </div>

      {selectedForm === "person" && <PersonForm />}
      {selectedForm === "member" && <MemberForm />}
      {selectedForm === "enquiry" && <EnquiryForm/>}
      <Footer />
    </>
  );
};

export default PersonFormPage;
